import axios from 'axios';
import instance from './api';
import {
  getRefreshToken,
  getToken,
  refreshRToken,
  refreshToken,
  setRefreshToken,
  setToken
} from '../services/auth.service';

const WORKPOINT_API_URL = process.env.REACT_APP_API_URL;

const setup = store => {
  instance.interceptors.request.use(
    config => {
      const token = getToken();
      if (token) {
        config.headers['x-access-token'] = token;
      }
      // config.headers['source'] = 'travel';
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  const { dispatch } = store;

  let isRefreshing = false;
  let refreshSubscribers = [];

  const refreshAccessToken = async () => {
    const storedToken = getRefreshToken();
    return await axios
      .post(`${WORKPOINT_API_URL}User/auth/refreshAdminToken`, {
        refreshToken: storedToken
      })
      .then(response => {
        if (response.data) {
          // let storage = JSON.parse(localStorage.getItem('user'));
          // storage.token = response.data.token;
          // storage.refresh_token = response.data.refreshToken;
          // localStorage.setItem('user', JSON.stringify(storage));
          setToken(response.data.token);
          setRefreshToken(response.data.refresh_token);
          dispatch(refreshToken(response.data.token));
          dispatch(refreshRToken(response.data.refresh_token));
          return response.data.token;
        }
      })
      .catch(e => {
        // localStorage.removeItem('accessToken');
        // localStorage.removeItem('refreshToken');
        // window.location.pathname = '/signin';
        // return e;
        throw e;
      });
  };

  /********************************* this version with fix refresh token ***********************************************/
  instance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      const {
        config,
        response: { status }
      } = error;
      const originalRequest = config;

      if (status === 401) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshAccessToken()
            .then(newToken => {
              isRefreshing = false;
              onRrefreshed(newToken);
            })
            .catch(() => {
              localStorage.removeItem('accessToken');
              localStorage.removeItem('refreshToken');
              window.location.pathname = '/signin';
            });
        }

        const retryOrigReq = new Promise((resolve, reject) => {
          subscribeTokenRefresh(token => {
            // replace the expired token and retry
            originalRequest.headers['x-access-token'] = token;
            originalRequest.baseURL = undefined;
            originalRequest._retry = false;
            resolve(axios(originalRequest));
          });
          // let storage = JSON.parse(localStorage.getItem("user"));
          // originalRequest.headers["x-access-token"] = storage.token;
          // originalRequest.baseURL = undefined;
          // originalRequest._retry = false;
          // resolve(axios(originalRequest));

          // return instance.request(err.config);
        });
        return retryOrigReq;
      } else if (status === 403) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.pathname = '/signin';
      } else {
        return Promise.reject(error);
      }
    }
  );

  function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb);
  }

  function onRrefreshed(token) {
    refreshSubscribers.map(cb => cb(token));
    // let storage = JSON.parse(localStorage.getItem('user'));
    // storage.token = token;

    // // storage.refresh_token = response.data.refreshToken;
    // localStorage.setItem('user', JSON.stringify(storage));
    setToken(token);
  }
};
export default setup;
